import React,{ useState, useEffect, useContext } from 'react';
import MaterialTable from 'material-table';
import CircularLoading from "../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import ConfirmationDialogRaw from '../components/ConfirmationDialogRaw';
import {
  dateStyle,
  language
} from 'config';
import { FirebaseContext } from 'common';
import {
  Typography,
} from '@material-ui/core';

const BookingHistory = () => {
  const { api } = useContext(FirebaseContext);
  const {
    cancelBooking,
    deleteBooking,
    updateBooking
  } = api;
  const dispatch = useDispatch();
  
  const columns =  [
      { title: language.booking_id, field: 'id' },
      { title: language.booking_date, field: 'bookingDate', render: rowData => rowData.bookingDate?new Date(rowData.bookingDate).toLocaleString(dateStyle):null},
      { title: language.customer_name,field: 'customer_name'},
      { title: language.coPassengers,render: rowData => rowData.coPassengers?<ol style={{width:200}}>{rowData.coPassengers.map(passenger=><li key={passenger}>{passenger}</li>)}</ol>:null },
      { title: language.pickup_address, field: 'pickupAddress' },
      { title: language.drop_address, field: 'dropAddress' },
      { title: language.assign_driver, field: 'driver_name' },
      { title: language.booking_status, field: 'status', render: rowData => <span>{language[rowData.status]}</span> },
      { title: language.cancellation_reason, field: 'reason'},
      { title: language.tripdate, field: 'tripdate', render: rowData => rowData.tripdate?new Date(rowData.tripdate).toLocaleString(dateStyle):null},
      { title: language.trip_start_time, field: 'trip_start_time' },
      { title: language.trip_end_time, field: 'trip_end_time' },
      { title: language.total_time, field: 'total_trip_time' },
      { title: language.vehicle_no, field: 'vehicle_number' },  
      { title: 'Admin Approved', field: 'adminApproved' , type:'boolean'}
  ];
  const [data, setData] = useState([]);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState('');
  const bookinglistdata = useSelector(state => state.bookinglistdata);
  const role= useSelector(state=>state.auth.info.profile.usertype);
  const settings = useSelector(state => state.settingsdata.settings);

  useEffect(()=>{
        if(bookinglistdata.bookings){
            setData(bookinglistdata.bookings);
        }else{
          setData([]);
        }
  },[bookinglistdata.bookings]);

  const onConfirmClose=(value)=>{
    if(value){
      dispatch(cancelBooking({
        reason:value,
        booking:selectedBooking
      }));
    }
    setOpenConfirm(false);
  }
  
  return (
    bookinglistdata.loading? <CircularLoading/>:
    <div>
    <MaterialTable
      title={language.booking_title}
      columns={columns}
      data={data}
      actions={[
        rowData => ({
          icon: () => <div style={{display: 'flex',alignItems: 'center',flexWrap: 'wrap'}}>
            <Typography variant="subtitle2">{'Approve'}</Typography>
          </div>,
          disabled: (rowData.status==='NEW' && settings.AdminApprovalRequired===true && rowData.hasOwnProperty('adminApproved')===false)? false:true,
          onClick: (event, rowData) => {
            let bookingData = rowData;
            bookingData['adminApproved'] = true;
            dispatch(updateBooking(bookingData));
          }         
        }),
        rowData => ({
          icon: () => <div style={{display: 'flex',alignItems: 'center',flexWrap: 'wrap'}}>
            <Typography variant="subtitle2">{'Cancel'}</Typography>
          </div>,
          tooltip: language.cancel_booking,
          disabled: rowData.status==='NEW' || rowData.status==='ACCEPTED'? false:true,
          onClick: (event, rowData) => {
            if(rowData.status==='NEW' || rowData.status==='ACCEPTED'){
              setSelectedBooking(rowData);
              setOpenConfirm(true);
            }else{
              setTimeout(()=>{
                dispatch(cancelBooking({
                  reason: language.cancelled_incomplete_booking,
                  booking:rowData
                }));
              },1500);
            }
          }         
        }),
        rowData => ({
          icon: () => <div style={{display: 'flex',alignItems: 'center',flexWrap: 'wrap'}}>
            <Typography variant="subtitle2">{'Delete'}</Typography>
          </div>,
          tooltip: language.delete_booking,
          disabled: role==='admin'? false:true,
          onClick: (event, rowData) => {
            setTimeout(()=>{
              dispatch(deleteBooking(rowData.id));
            },1500);
          }         
        })
      ]}
    />
    <ConfirmationDialogRaw
      open={openConfirm}
      onClose={onConfirmClose}
      value={''}
    />
    </div>

  );
}

export default BookingHistory;
